import { Component } from '@angular/core';
import { LeadDashboardService } from './lead-dashboard.service';
import { AsyncPipe } from '@angular/common';
import { SelectedLeadsViewComponent } from './selected-leads-view/selected-leads-view.component';
import { LeadTaskComponent } from './lead-task/lead-task.component';
import { RouteInformationService } from './route-information.service';

@Component({
  selector: 'app-lead-dashboard',
  imports: [AsyncPipe, SelectedLeadsViewComponent, LeadTaskComponent],
  templateUrl: './lead-dashboard.component.html',
  styleUrl: './lead-dashboard.component.scss',
  providers: [LeadDashboardService, RouteInformationService],
})
export class LeadDashboardComponent {
  constructor(public leadDashboardService: LeadDashboardService) {}
}
